import React from 'react';
import './Projects.css';

const Projects = () => {
  return (
    <>
      <section
        style={{ overflow: 'hidden' }}
        className='portfolio container'
        id='portfolio'
      >
        <div
          data-aos='zoom-in'
          data-aos-duration='2000'
          className='aos-init aos-animate'
        >
          <h1 className='heading'>
            My Recent<span>Works</span>
          </h1>
          <h6 className='heading-info'>
            Here are a few projects I've worked on recently.
          </h6>
        </div>
        <div className='container'>
          <div className='container-items'>
            <div
              className='card-one'
              data-aos='fade-down-right'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
            >
              <div className='about'>
                <h2>Travel-Vela</h2>
                <p>Travel-Vela is a travel agency landing page.</p>
              </div>
              <div className='button-group'>
                <div className='button'>
                  <a
                    id='git-btn'
                    type='button'
                    target='_blank'
                    href='https://github.com/masudtalukdar/travel-vela-client-side'
                    rel='noreferrer'
                  >
                    GitHub Repo
                  </a>
                  <a
                    id='liveSite-btn'
                    type='button'
                    target='_blank'
                    href='https://travel-vela.web.app/'
                    rel='noreferrer'
                  >
                    Live Site
                  </a>
                </div>
              </div>
            </div>
            <div
              className='card-two'
              data-aos='zoom-in'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
            >
              <div className='about'>
                <h2>Drone</h2>
                <p>Drone is a Drone-shop landing page.</p>
              </div>
              <div className='button-group'>
                <div className='button'>
                  <a
                    id='git-btn'
                    type='button'
                    target='_blank'
                    href='https://github.com/masudtalukdar/drone-shop-client-side'
                    rel='noreferrer'
                  >
                    GitHub Repo
                  </a>
                  <a
                    id='liveSite-btn'
                    type='button'
                    target='_blank'
                    href='https://drone-shop-2f2e9.web.app/'
                    rel='noreferrer'
                  >
                    Live Site
                  </a>
                </div>
              </div>
            </div>
            <div
              className='card-three'
              data-aos='fade-down-left'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
            >
              <div className='about'>
                <h2>Luminous-Dentistry</h2>
                <p>luminous-dentistry is a dentist clinic landing page.</p>
              </div>
              <div className='button-group'>
                <div className='button'>
                  <a
                    id='git-btn'
                    type='button'
                    target='_blank'
                    href='https://github.com/masudtalukdar/luminous-dentistry'
                    rel='noreferrer'
                  >
                    GitHub Repo
                  </a>
                  <a
                    id='liveSite-btn'
                    type='button'
                    target='_blank'
                    href='https://luminous-dentistry.web.app/'
                    rel='noreferrer'
                  >
                    Live Site
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;
